import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0c5df91f")
const _hoisted_1 = ["for"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-bold p-pt-2 p-pb-2 header" }, "Vistas guardados", -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "p-mb-2"
}
const _hoisted_6 = { class: "p-jc-between p-mt-1 p-d-flex" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 1 }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_ScrollPanel = _resolveComponent("ScrollPanel")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      type: "button",
      class: "p-text-left btn-custom-view",
      icon: "pi pi-chevron-down",
      iconPos: "right",
      label: 'Tabla',
      onClick: _ctx.toggle,
      "aria:haspopup": "true",
      "aria-controls": "overlay_panel_custom"
    }, null, 8, ["onClick"]),
    _createVNode(_component_OverlayPanel, {
      ref: "op",
      appendTo: "body",
      class: "p-mt-0 bg-gray-400",
      id: "overlay_panel_custom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TabView, {
          ref: "tabview1",
          class: "bg-gray-400",
          activeIndex: _ctx.activeIndex,
          "onUpdate:activeIndex": _cache[4] || (_cache[4] = ($event: any) => (_ctx.activeIndex = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TabPanel, { header: "Columnas" }, {
              default: _withCtx(() => [
                _createVNode(_component_ScrollPanel, { style: {"width":"100%","max-height":"140px"} }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allColumns, (column) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: column.field,
                        class: "p-mb-2 p-d-flex p-ai-center"
                      }, [
                        _createVNode(_component_Checkbox, {
                          class: "p-m-2 bg-gray-400",
                          id: column.field,
                          name: "selectedColumns",
                          value: column.field,
                          modelValue: _ctx.selectedColumnsRef,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedColumnsRef = $event)),
                          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitsChangeColums($event)))
                        }, null, 8, ["id", "value", "modelValue"]),
                        _createElementVNode("label", {
                          for: column.field
                        }, _toDisplayString(column.header), 9, _hoisted_1)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                }),
                _hoisted_2,
                _hoisted_3,
                (_ctx.allViews.length)
                  ? (_openBlock(), _createBlock(_component_ScrollPanel, {
                      key: 0,
                      style: {"width":"100%","max-height":"100px"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allViews, (view) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: view.name.trim(),
                            class: "p-d-flex p-jc-between p-ai-center custom-item",
                            onClick: ($event: any) => (_ctx.returnToNull(view))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(view.name), 1),
                            _createVNode(_component_Button, {
                              class: "p-button-rounded p-button-text",
                              icon: "pi pi-trash",
                              onClick: ($event: any) => (_ctx.deleteFilter(view))
                            }, null, 8, ["onClick"])
                          ], 8, _hoisted_4))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.allViews?.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, "No hay vistas guardadas"))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Button, {
                    type: "button",
                    class: "p-button-text",
                    label: 'Cancelar',
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggle($event)))
                  }),
                  _createVNode(_component_Button, {
                    type: "button",
                    label: 'Guardar',
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emitToggleCreateFilter()))
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, { header: "Filtros" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  (_ctx.allFilters.length)
                    ? (_openBlock(), _createBlock(_component_ScrollPanel, {
                        key: 0,
                        style: {"width":"100%","max-height":"100px"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFilters, (filter) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: filter.name.trim(),
                              class: "p-d-flex p-jc-between p-ai-center custom-item",
                              onClick: ($event: any) => (_ctx.returnToNull(filter))
                            }, [
                              _createElementVNode("span", null, _toDisplayString(filter.name), 1),
                              _createVNode(_component_Button, {
                                class: "p-button-rounded p-button-text",
                                icon: "pi pi-trash",
                                onClick: ($event: any) => (_ctx.deleteFilter(filter))
                              }, null, 8, ["onClick"])
                            ], 8, _hoisted_7))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.allFilters?.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, "No hay filtros guardados"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["activeIndex"])
      ]),
      _: 1
    }, 512)
  ], 64))
}